// extracted by mini-css-extract-plugin
export default {"drawer__outside":"Drawer_drawer__outside__N5jBf","drawer__inside":"Drawer_drawer__inside__GGWts","drawer-up":"Drawer_drawer-up__mYzzP"};